function objectAsParams(object = {}) {
  let params = '';
  let index = 0;
  for (const [key, value] of Object.entries(object)) {
    index !== 0 && (params += '&');
    params += `${key}=${value}`;
    index++;
  }

  return params;
}
export  { objectAsParams }